const firebaseConfig = {
  apiKey: 'AIzaSyAL5KBZcTHro5PyD6pUxouywOHHgryKSwU',
  authDomain: 'elsa-app-bd2f8.firebaseapp.com',
  databaseURL: 'https://elsa-app-bd2f8.firebaseio.com',
  projectId: 'elsa-app-bd2f8',
  storageBucket: 'elsa-app-bd2f8.appspot.com',
  messagingSenderId: '413683105247',
  appId: '1:413683105247:web:9cf0e50e40c199e0df586a',
  measurementId: 'G-QKD8S98M2B',
};

export default firebaseConfig;
